import { closeContext, createContext } from "@otto-ec/tracking-bct";
import { untrack } from "svelte";
import { sheetScope } from "../utils/props";
import type { useExternalContent } from "../content/loader.svelte";
import type { OcSheetV1InstanceState } from "./stack.svelte";

const log = /*           */ sheetScope.scope("tracking");

/**
 *
 *
 *
 *
 *
 *
 */
/*                                                                        */
export const useTrackingContext = (
  init: { sheetId: () => string },
  instanceState: OcSheetV1InstanceState,
  externalContent: ReturnType<typeof useExternalContent>,
): void => {
  const { sheetId } = init;
  /**
 *
 */
  let contextOpen = false;

  $effect(() => {
    const { validUrl, rawContent } = externalContent;

    if ((instanceState.isActive && rawContent !== null) || !contextOpen) return;
    if (import.meta.env.DEV) log.info("Closing tracking context for sheet", sheetId, validUrl);
    closeContext();

    contextOpen = false;
  });

  $effect(() => {
    const active = untrack(() => instanceState.isActive);
    const { validUrl, rawContent } = externalContent;

    /*                                                      */
    /*                                                  */
    if (!active || !sheetId() || !validUrl || rawContent === null || contextOpen) return;

    if (import.meta.env.DEV) log.info("Creating tracking context for sheet", sheetId(), validUrl);
    createContext(sheetId(), validUrl, { ts_OttoComponent: ["sheet@v1"] });

    contextOpen = true;
  });
};
